import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export interface SystemState {
  errors: string[]
}

const initialState: SystemState = {
  errors: [],
}

const SystemSlice = createSlice({
  name: 'System',
  initialState,
  reducers: {
    pushError: (state, action: PayloadAction<string>) => {
      state.errors.push(action.payload)
    },
    popError: (state) => {
      state.errors.pop()
    },
  },
})

export default SystemSlice
